import { useEffect, useState } from "react";
import { C } from "../theme/colors";
import Divider from "../components/Divider";
import Section from "../components/Section";
import PageHero from "../components/PageHero";

const MEDIA_LIST_API_URL = "https://ccapi.rapifuzz.in:8443/api/media-list/";

// Kept as a fallback so the page never renders empty if the API is unreachable
const staticMedia = [
  {name:"Economic Times",url:"https://economictimes.indiatimes.com"},
  {name:"Hindustan Times",url:"https://hindustantimes.com"},
  {name:"Indian Express",url:"https://indianexpress.com"},
  {name:"India Today",url:"https://indiatoday.in"},
  {name:"Telangana Today",url:"https://telanganatoday.com"},
  {name:"Career360",url:"https://careers360.com"},
];

export default function MediaCoveragePage() {
  const [media, setMedia] = useState(staticMedia);

  useEffect(() => {
    let cancelled = false;

    fetch(MEDIA_LIST_API_URL)
      .then(res => {
        if (!res.ok) throw new Error(`Request failed (${res.status})`);
        return res.json();
      })
      .then(json => {
        if (cancelled) return;
        const list = Array.isArray(json?.data) ? json.data : [];
        const active = list
          .filter(m => (m.status || "").toLowerCase() === "active")
          .map(m => ({ name: m.title, url: m.link }));
        if (active.length) setMedia(active);
      })
      .catch(() => {
        // Silently keep the static fallback list on any failure
      });

    return () => { cancelled = true; };
  }, []);

  return (
    <div className="page-fade">
      <PageHero title="Media Coverage" tag="In The Press" subtitle="CRENS in the news — coverage from India's leading publications." />
      <Section>
        <div style={{marginBottom:32}}>
          <span className="section-tag">Press</span>
          <h2 style={{fontFamily:"var(--font-heading)",fontWeight:600,color:C.navyDark,fontSize:"clamp(1.5rem,2.5vw,2.2rem)",marginTop:10}}>{media.length} Articles &amp; Mentions</h2>
          <Divider/>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:14}}>
          {media.map((m,i) => (
            <a key={i} href={m.url} target="_blank" rel="noopener noreferrer" style={{textDecoration:"none",padding:"18px 20px",borderRadius:10,border:`1px solid ${C.border}`,background:C.white,display:"flex",alignItems:"center",justifyContent:"space-between",transition:"all .2s"}} onMouseEnter={e=>{e.currentTarget.style.borderColor=C.accentDeep;e.currentTarget.style.background=C.accent;e.currentTarget.style.transform="translateY(-2px)";}} onMouseLeave={e=>{e.currentTarget.style.borderColor=C.border;e.currentTarget.style.background=C.white;e.currentTarget.style.transform="none";}}>
              <span style={{fontFamily:"Arial,Helvetica,sans-serif",fontSize:14,fontWeight:600,color:C.navyDark}}>{m.name}</span>
              <span style={{color:C.blue,fontSize:14}}>↗</span>
            </a>
          ))}
        </div>
      </Section>
    </div>
  );
}